import React from "react";
import GuideHeader from "../Guide/GuideHeader";
import "./GuideMeasureSuccess.css";

const GuideMeasureSuccess = () => {
  const metrics = [
    {
      number: 1,
      title: "Open rate",
      text: `The open rate tracks how many subscribers open the email you sent. Open rates can give you an idea of how successful the subject line and preview text is, as well as the quality of your subscriber list.

Most email campaigns average an open rate of about 21% across all industries. If your open rates are higher than that, great! But your industry could just have a lower average, so find out what a good result would look like for you.`,
    },
    {
      number: 2,
      title: "Bounce rate",
      text: `When an email can’t be delivered to a recipient, it’s recorded as a bounce. There are two types of bounces:

Soft
This means a temporary issue stopped the email being delivered. This could mean that the recipient’s mailbox is full, their email provider is having issues, or your email was too large. Sometimes it just means an out-of-office response was received.

Hard
This means a permanent issue stopped the email being delivered. This could mean that the email address doesn’t exist, or an email provider blocked delivery of your email. If an contact hard-bounces, we unsubscribe the email address from your lists so it’s not contacted again – this is done to maintain your sender reputation.`,
    },
    {
      number: 3,
      title: "Unsubscribes",
      text: `It’s important to look at how many people are unsubscribing from your emails – this will tell you whether your contacts find your content relevant. But it isn’t always a bad thing if people are unsubscribing.

It gives you the opportunity to make sure you’re sending the right content to the right contacts and make adjustments as needed. You should find this metric getting lower as you fine-tune your marketing strategy.`,
    },
    {
      number: 4,
      title: "List growth rate",
      text: `This lets you know how many subscribers you’re adding or losing over time. It’s natural for your list growth rate to fluctuate slightly but if you see a consistent downward trend, it’s time to re-evaluate your marketing strategy.

If you’re seeing consistent growth, then you know that your strategy is working for you.`,
    },
    {
      number: 5,
      title: "Spam complaints",
      text: `You really want to take close note of any spam complaints and try to understand why you’re receiving them. Consistently high spam complaints can lead to an account suspension or permanent ban. If you’re creating high-quality lists, you should get very few spam complaints.`,
    },
    {
      number: 6,
      title: "Click rate",
      text: `Click rates help you understand how engaged your subscribers are and how interested they are in what you’re marketing to them. If you have a high open rate but a low click rate, you may want to re-evaluate if your subject line and preview text are accurately representing your email’s content.

It’s easy to check these metrics and others in your Mailsnappy dashboard. Just click on the Reports tab at the top of the page in your account and choose which campaign you’d like to see the report for.`,
    },
  ];

  return (
    <div className="guide-page">
      {/* ✅ Shared Header */}
      <GuideHeader headingLevel="div" />

      {/* 📧 Content Section */}
      <section className="measure-content">
        <h1>How to measure the success of your email campaigns</h1>
        <p className="intro-text">
          So you’ve built a campaign, got the perfect personalised subject line and sent it out into
          the world. How do you know if it’s been a success? Reviewing your metrics will help you
          understand if your emails are helping you achieve your marketing goals.
        </p>
        <p className="intro-sub">
          Here are some of the main metrics you can (and should) review after each campaign:
        </p>

        <div className="measure-metrics">
          {metrics.map((metric) => (
            <div key={metric.number} className="metric-box">
              <div className="metric-number">{metric.number}</div>
              <div className="metric-content">
                <h3>{metric.title}</h3>
                <p>{metric.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="congrats-section">
          <h3>Congratulations!</h3>
          <p>
            You’ve now covered all of the basics and some of the more advanced capabilities of email
            marketing. Go ahead and delight your subscribers!
          </p>
        </div>
      </section>

      {/* 🌊 CTA Section */}
      <section className="guide-start">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
      </section>
    </div>
  );
};

export default GuideMeasureSuccess;
